import React from "react";
import { Link } from "react-router-dom";
import { PartyPopper } from "lucide-react";

const Step = ({ n, children }) => (
  <li className="flex gap-4" data-testid={`youre-in-step-${n}`}>
    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full font-head text-sm font-semibold text-white tenant-bg">{n}</span>
    <div className="pt-1 text-neutral-700">{children}</div>
  </li>
);

const ToolLink = ({ to, label, testid }) => (
  <Link to={to} data-testid={testid}
    className="rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90"
    style={{ backgroundColor: "var(--tenant-primary)" }}>{label}</Link>
);

export default function YoureInPanel() {
  return (
    <div className="rounded-2xl border border-[#E5E2DC] bg-white p-8" data-testid="youre-in-panel">
      <span className="grid h-12 w-12 place-items-center rounded-xl" style={{ backgroundColor: "var(--tenant-primary-light)" }}>
        <PartyPopper className="tenant-text" strokeWidth={1.5} />
      </span>
      <h2 className="mt-5 font-head text-2xl font-semibold text-neutral-900">You're in! Here's what happens next</h2>
      <ol className="mt-6 space-y-5">
        <Step n={1}>
          <span className="font-semibold text-neutral-900">Watch your inbox.</span> Within 24 hours, you'll get an email with your login for the full FISBO training. Check your spam and promotions folders too.
        </Step>
        <Step n={2}>
          <p><span className="font-semibold text-neutral-900">Don't wait. Start now.</span> While we get you set up, plug your numbers into the tools:</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <ToolLink to="/pnl-decoder" label="P&L Decoder" testid="youre-in-decoder-btn" />
            <ToolLink to="/calculator" label="Profit Calculator" testid="youre-in-calculator-btn" />
          </div>
        </Step>
        <Step n={3}>
          <span className="font-semibold text-neutral-900">Already have your login?</span> Use the personal link in your welcome email to open your training.
        </Step>
      </ol>
      <p className="mt-6 text-sm italic text-neutral-500" data-testid="youre-in-footer">Progress, not perfection.</p>
    </div>
  );
}
